// src/pages/permission/PermissionForm.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  TextField,
  Button,
  Typography,
  Grid,
  FormHelperText,
  Card,
  CardContent,
} from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import permissionService from '../../services/permissionService';
import LayoutContainer from '../../components/LayoutContainer';
import AdminHeader from '../../components/AdminHeader';
import { omit, toUpper } from 'lodash';

const PermissionForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    name: '',
  });

  useEffect(() => {
    const fetchPermssion = async () => {
      if (id) {
        const response = await permissionService.getPermission(id);
        setInitialValues({
          name: response.data.name,
        });
      }
    };
    fetchPermssion();
  }, [id]);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Permission is required'),
  });

  const handleSubmit = async (values) => {
    if (id) {
      await permissionService.updatePermission(id, values);
    } else {
      await permissionService.createPermission(values);
    }
    navigate('/permissions');
  };

  return (
    <LayoutContainer>
      <AdminHeader
        title={id ? 'Edit Permission' : 'Add Permission'}
        backTo='/permissions'
      />
      <Box
        className='page-content-wrapper scrollable'
        p={3}
        sx={{ display: 'flex', backgroundColor: '#efefef' }}
      >
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ handleChange, handleBlur, values, errors, touched }) => (
            <Form style={{ width: '50%' }}>
              <Card>
                <CardContent>
                  <Grid container spacing={3} sx={{ p: 1 }}>
                    <Grid item xs={12}>
                      <Typography variant='body2' sx={{ fontWeight: 600 }}>
                        Permission <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <TextField
                        name='name'
                        fullWidth
                        value={values.name}
                        onChange={(e) => {
                          const capitalizedValue = toUpper(e.target.value); // Capitalize first letter
                          handleChange({
                            target: { name: 'name', value: capitalizedValue },
                          });
                        }}
                        onBlur={handleBlur}
                        sx={{
                          backgroundColor: '#f5f5f5',
                          borderRadius: 1,
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor:
                                touched.contact_name && errors.contact_name
                                  ? '#d32f2f'
                                  : '#ccc',
                            },
                          },
                        }}
                      />
                      {touched.name && errors.name && (
                        <FormHelperText error>{errors.name}</FormHelperText>
                      )}
                    </Grid>
                  </Grid>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <Button
                      type='submit'
                      variant='contained'
                      sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
                    >
                      {id ? 'Update' : 'Create'}
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Form>
          )}
        </Formik>
      </Box>
    </LayoutContainer>
  );
};

export default PermissionForm;
